import { NotificationSeverity } from '../services/notifier';
import { Notification } from './notification';

export class NotificationSuccess extends Notification {
  protected severity: NotificationSeverity = 'success';
}
